namespace $.$$ {
	export class $shm_hitalama_components_editor extends $.$shm_hitalama_components_editor {
		content() { return [ this.Deck_switch(), this.Deck_content(), ...this.feedback() ] }
		editable() { return this.definition().can_change() }
		@ $mol_mem
		tree( next?: string ) { return this.definition().source_text( 'tree', next ) }
		@ $mol_mem
		logic( next?: string ) { return this.definition().source_text( 'logic', next ) }
		@ $mol_mem
		style_code( next?: string ) { return this.definition().source_text( 'style', next ) }
		@ $mol_mem
		dependencies( next?: string ) { return this.definition()?.Dependencies( next === undefined ? undefined : null )?.val( next ) ?? '' }
		@ $mol_mem
		demo( next?: string ) { return this.definition().source_text( 'demo', next ) }
		save_status() { return [ this.Default(), this.Readme(), this.Demo(), this.Tree(), this.Logic(), this.Style() ].map( source => source.failure() ).filter( Boolean ).join( '\n' ) }
		saving() { return [ this.Default(), this.Readme(), this.Demo(), this.Tree(), this.Logic(), this.Style() ].some( source => source.saving() ) }
		feedback() { return this.save_status() ? [ this.Save_status() ] : [] }
	}
}
